<template>
    <div class="md-example-child md-example-child-result-page md-example-child-result-page-2">
        <md-result-page
                type="empty"
                :buttons="buttons"
        ></md-result-page>
    </div>
</template>

<script>
    import {ResultPage, Toast} from 'mand-mobile'

    export default {
        name: 'pay',
        components: {
            [ResultPage.name]: ResultPage,
        },
        data() {
            return {
                buttons: [
                    {
                        text: '普通按钮',
                        handler() {
                            Toast.succeed('普通操作')
                        },
                    },
                    {
                        text: '高亮按钮',
                        type: 'primary',
                        handler() {
                            Toast.succeed('不普通操作')
                        },
                    },
                ],
            }
        },
    }

</script>

<style lang="stylus">
    .md-example-child-result-page-2
        padding-top 200px
        background #FFF
</style>